import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import { readCookie, removeCookie } from '@/tools/tools';
import { productTypeListPC, productTypeList, getIndexNav as _getIndexNav, getIndexNavDetails as _getIndexNavDetails, receiveCoupon } from '@/services/http';
import * as _ from 'lodash';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isLoading = false;
    _this.value = '';
    _this.isLogin = false;
    _this.isShow = readCookie('anchor');
    _this.isClassifyShow = false;
    _this.productTypeId = 0;
    _this.imageHeight = 0;
    // 导航第一个分类id
    _this.firstProductId = '';
    // 分类列表
    _this.productTypeList = [];
    // 分类列表子分类
    _this.productTypeChildren = [];
    _this.classifyIndex = 0;
    _this.currentIndex = -1;
    _this.isMenuShow = false;
    _this.navList = [];
    _this.dataInfo = {};
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getIndexNavDetails();
      this.getIndexNav();
      this.getProductTypeList();
    }
  }, {
    key: "handleCommand",
    value: function handleCommand(command) {
      if (command === 'login') {
        var anchor = readCookie('anchor');
        if (anchor) {
          if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
            this.webTransport.getUserLoginData(JSON.stringify({}));
          } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
            window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify({}));
          } else {
            window.JsIntrS.getUserLoginData({});
          }
        }
        removeCookie('accessToken');
        this.$router.push('/login');
      } else {
        this.$router.push('/user');
      }
    }
    // 比较版本
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      v1 = v1.split('.');
      v2 = v2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
        v1.push('0');
      }
      while (v2.length < len) {
        v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i]);
        var num2 = parseInt(v2[i]);
        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }
      return 0;
    }
  }, {
    key: "goback",
    value: function goback() {
      this.$router.back();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      window.location.reload();
    }
  }, {
    key: "goOrderList",
    value: function goOrderList() {
      window.location.href = '/order-list';
    }
  }, {
    key: "goMessage",
    value: function goMessage() {
      this.$router.push('/notifys');
    }
  }, {
    key: "search",
    value: function search() {
      if (this.value) {
        window.location.href = "/classify?keyword=".concat(this.value);
      } else {
        this.$message.error('请输入商品名称或品牌');
      }
    }
  }, {
    key: "dropdownClassify",
    value: function dropdownClassify() {
      this.dropdownClick(Number(this.firstProductId), 0);
      this.currentIndex = 0;
      this.isClassifyShow = true;
      this.isMenuShow = true;
    }
  }, {
    key: "selectHref",
    value: function () {
      var _selectHref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(item.urlType === 2)) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return receiveCoupon({
                couponId: item.url,
                productId: ''
              });
            case 3:
              res = _context.sent;
              if (res.data.code === 100) {
                this.$message.success('领取成功');
              } else {
                this.$message.success(res.data.message);
              }
              _context.next = 8;
              break;
            case 7:
              window.location.href = item.url;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function selectHref(_x) {
        return _selectHref.apply(this, arguments);
      }
      return selectHref;
    }()
  }, {
    key: "getProductTypeList",
    value: function () {
      var _getProductTypeList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return productTypeListPC({
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              this.productTypeList = res.data.data;
              this.firstProductId = res.data.data[0].id;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProductTypeList() {
        return _getProductTypeList.apply(this, arguments);
      }
      return getProductTypeList;
    }()
  }, {
    key: "dropdownClick",
    value: function () {
      var _dropdownClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(productTypeId, index) {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.currentIndex = index;
              this.productTypeId = productTypeId;
              _context3.next = 4;
              return productTypeList({
                productTypeId: productTypeId,
                companyId: 1
              });
            case 4:
              res = _context3.sent;
              if (res.data.code === 100) {
                this.productTypeChildren = res.data.data.children;
                this.classifyIndex = this.productTypeChildren.length;
                this.isMenuShow = true;
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function dropdownClick(_x2, _x3) {
        return _dropdownClick.apply(this, arguments);
      }
      return dropdownClick;
    }()
  }, {
    key: "goDetails",
    value: function goDetails(productTypeId) {
      window.location.href = "/classify?productTypeId=".concat(productTypeId);
    }
    // 浏览更多
  }, {
    key: "watchMore",
    value: function watchMore() {
      this.$router.push("/classify?parentTypeId=".concat(this.productTypeId));
    }
  }, {
    key: "mouseLeave",
    value: function mouseLeave() {
      if (this.$route.name !== 'home') {
        this.isClassifyShow = false;
      }
      this.isMenuShow = false;
      this.currentIndex = -1;
    }
  }, {
    key: "getIndexNavDetails",
    value: function () {
      var _getIndexNavDetails2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this2 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.isLoading = true;
              if (!this.$route.query.id) {
                this.$router.push('/');
                this.$message.error('数据有误，请重新进入');
              }
              _context4.next = 4;
              return _getIndexNavDetails({
                id: this.$route.query.id
              });
            case 4:
              res = _context4.sent;
              if (res.data.code === 100) {
                this.dataInfo = res.data.data;
                this.isLoading = false;
                this.imageHeight = Number(this.dataInfo.topicImage.height);
                //       top: (Number(item.id.split(',')[1]) / dataInfo.topicImage.height) * 100 + '%',
                // left: (Number(item.id.split(',')[0]) / 1198) * 100 + '%',
                // width: (Number(item.id.split(',')[2]) / 1198) * 100 + '%',
                // height: (Number(item.id.split(',')[3]) / dataInfo.topicImage.height) * 100 + '%',
                this.dataInfo.list.forEach(function (value) {
                  _this2.$set(value, 'top', _.round(_.multiply(_.divide(Number(value.id.split(',')[1]), _this2.imageHeight), 100), 2));
                  _this2.$set(value, 'left', _.round(_.multiply(_.divide(Number(value.id.split(',')[0]), 1198), 100), 2));
                  _this2.$set(value, 'width', _.round(_.multiply(_.divide(Number(value.id.split(',')[2]), 1198), 100), 2));
                  _this2.$set(value, 'height', _.round(_.multiply(_.divide(Number(value.id.split(',')[3]), _this2.imageHeight), 100), 2));
                });
                // this.setList();
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getIndexNavDetails() {
        return _getIndexNavDetails2.apply(this, arguments);
      }
      return getIndexNavDetails;
    }()
  }, {
    key: "openWin",
    value: function openWin(item) {
      if (item.navType === 1) {
        this.$router.push("/classify?productTypeId=".concat(item.navTypeValue));
      } else if (item.navType === 2) {
        this.$router.push("/details?id=".concat(item.navTypeValue));
      } else if (item.navType === 3) {
        this.$router.push("/special?id=".concat(item.id));
      } else {
        this.$router.push('/consumables');
      }
    }
  }, {
    key: "setList",
    value: function setList() {
      if (this.dataInfo.type === 2) {
        this.dataInfo.list = this.dataInfo.list.map(function (item) {
          var data = item;
          var arr = data.id.split(',').map(Number);
          // eslint-disable-next-line no-mixed-operators
          // arr.splice(0, 1, (1200 / width) * arr[2] + arr[0] - 30);
          // arr.splice(2, 1, (1200 / width) * arr[2] + arr[2]);
          data.id = arr.join(',');
          return data;
        });
      } else {
        this.$router.push('/');
        this.$message.error('数据有误，请重新进入');
      }
    }
    // 获取专题页
  }, {
    key: "getIndexNav",
    value: function () {
      var _getIndexNav2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _getIndexNav({
                type: 2,
                companyId: 1
              });
            case 2:
              res = _context5.sent;
              if (res.data.code === 100) {
                this.navList = res.data.data;
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getIndexNav() {
        return _getIndexNav2.apply(this, arguments);
      }
      return getIndexNav;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;